"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerScript = void 0;
var registerScript = function (_a) {
    var src = _a.src, onLoad = _a.onLoad;
    // NOTE: for SSR Gatsby
    if (typeof document === "undefined") {
        return;
    }
    var script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = onLoad;
    document.body.appendChild(script);
};
exports.registerScript = registerScript;
//# sourceMappingURL=register-script.js.map